import Checkbox from '@/app/components/common/Checkbox'
import Text from '@/app/components/common/Text'
import { SM_BREAKPOINT } from '@/app/constants'
import { Filters } from '@/app/types'
import { useMediaQuery } from '@uidotdev/usehooks'
import { useTranslations } from 'next-intl'
import { FC } from 'react'

interface StarRatingFilterProps {
	localValue: Filters
	availableFilters: {
		id: number
	}[]
	handleStarChange: (star: number, track: boolean) => void
}

const StarRatingFilter: FC<StarRatingFilterProps> = ({
	localValue,
	availableFilters,
	handleStarChange,
}) => {
	const t = useTranslations('Keywords')
	const isMobile = useMediaQuery(SM_BREAKPOINT)

	if (availableFilters.length === 0) {
		return null
	}

	const getStarLabel = (starCount: number): string => {
		return starCount === 1 ? t('oneStarHotels') : t('starHotels', { starCount })
	}

	const handleCheckboxChange = (star: number) => {
		handleStarChange(star, true)
	}

	return (
		<div className="hotel-list-filters__section">
			<Text size="base" font="semibold" className="hotel-list-filters__title">
				{t('starRatingFilter')}
			</Text>
			<div className="hotel-list-filters__stars">
				{availableFilters.map((starObj) => {
					const star = starObj.id
					const starLabel = getStarLabel(star)
					const isChecked = localValue.stars.includes(star)

					return (
						<div
							key={star}
							className="hotel-list-filters__stars-star hotel-list-filters__item"
						>
							<Checkbox
								variant="main-dark"
								checked={isChecked}
								testId={`star-${star}`}
								onChange={() => handleCheckboxChange(star)}
								labelRight={isMobile ? undefined : starLabel}
								labelLeft={isMobile ? starLabel : undefined}
								bold={false}
							/>
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default StarRatingFilter
